import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoWhitespaceValidator(message = null): ValidatorFn {
  return (control: AbstractControl) => {
    let controlVal = control.value;
    if (typeof controlVal === 'number') {
      controlVal = `${controlVal}`;
    }
    if (typeof controlVal === 'object') {
      if (controlVal) {
        return null;
      } else {
        // return new TuiValidationError(message ? message : 'Bắt buộc nhập');
        return { empty: { message: message ? message : 'Bắt buộc nhập' } };
      }
    }
    const isWhitespace = (controlVal || '').trim().length === 0;
    if (isWhitespace) {
        return { empty: { message: message ? message : 'Bắt buộc nhập' } };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/validators/no-whitespace.validator.ts